module.exports = __webpack_public_path__ + "static/media/social-instagram.a57cb906.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth/social-instagram.svg
// module id = 416
// module chunks = 0